import React from "react";
import { Box, Flex, Text } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

const WeeklyClassHours = ({ weeklyClassHours, classHours }) => {
  const { t } = useTranslation();

  const translation = t("teacherReportCard").statistics.weeklyClassHours;

  return (
    <div
      style={{
        border: "1px solid #f2f2f2",
        padding: "5px",
        height: "fit-content",
        maxWidth: "450px",
        minWidth: "400px",
      }}
    >
      <div
        style={{
          backgroundColor: "#f2f2f2",
          padding: "2px 5px",
          borderBottom: "1px solid #ccc",
        }}
      >
        <Text content={translation.title} weight="bold" align="center" />
      </div>
      <Flex fill>
        <Box className="left-section" style={{ flexGrow: 1 }}>
          <Flex
            style={{
              backgroundColor: "#f2f2f2",
              padding: "2px 5px",
            }}
            hAlign="center"
          >
            <Text
              content={translation.class}
              weight="semibold"
              align="center"
            />
          </Flex>
          {Object.keys(classHours).map((key, i) => (
            <Flex
              key={`${key}-${i}`}
              hAlign="center"
              style={{ padding: "2px 25px" }}
            >
              <Text content={key} truncated title={key} />
            </Flex>
          ))}
          <Flex
            style={{
              backgroundColor: "#f2f2f2",
              padding: "2px 8px",
            }}
            hAlign="center"
          >
            <Text
              content={translation.total}
              weight="semibold"
              align="center"
            />
          </Flex>
        </Box>
        <Box className="right-section">
          <div style={{ backgroundColor: "#f2f2f2", padding: "2px 8px" }}>
            <Text
              content={translation.hours}
              weight="semibold"
              align="center"
            />
          </div>
          {Object.values(classHours).map((value, i) => (
            <Flex
              key={`classHours-${i}`}
              hAlign="center"
              style={{ padding: "2px 8px" }}
            >
              <Text content={value} title={value} />
            </Flex>
          ))}
          <div style={{ backgroundColor: "#f2f2f2", padding: "2px 8px" }}>
            <Text content={weeklyClassHours} weight="semibold" align="center" />
          </div>
        </Box>
      </Flex>
    </div>
  );
};

export default WeeklyClassHours;
